import { NotifyHelper } from "../../../helpers/toast";
import { eBoMonActionsObj } from "../../action-types/category/IBoMonActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const boMonActions = {
    ...generateActions(eBoMonActionsObj, "BO_MON"),
    ...generateActionForKey(eBoMonActionsObj, "BO_MON", "LOAD_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
}